var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineNote2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.99 20.14c-.52-.04-1.11-.14-1.72-.29l-1.68-.4c-4.61-1.09-6.12-3.53-5.04-8.13l.98-4.19c.22-.95.48-1.72.8-2.36 1.72-3.55 5.01-3.23 7.35-2.68l1.67.39c2.34.55 3.82 1.42 4.65 2.75.82 1.33.95 3.04.4 5.38l-.98 4.18c-.86 3.66-2.65 5.39-5.61 5.39-.26 0-.53-.01-.82-.04zM9.68 5.42c-.26.54-.49 1.21-.69 2.05l-.98 4.19c-.89 3.78.14 5.43 3.92 6.33l1.68.4c.54.13 1.05.21 1.51.25 2.72.27 4.07-.92 4.83-4.19l.98-4.18c.45-1.93.39-3.28-.21-4.25-.6-.97-1.78-1.63-3.72-2.08l-1.67-.39c-.83-.2-1.57-.3-2.21-.3-1.67 0-2.73.69-3.44 2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.07 17.46-1.28-3.95c-1.42-4.4-.15-6.88 4.23-8.3L7.6 4.7c.52-.16.91-.27 1.26-.33.29-.06.57.05.74.28.17.23.2.53.08.79-.26.53-.49 1.2-.68 2.04l-.98 4.19c-.89 3.78.14 5.43 3.92 6.33l1.68.4c.54.13 1.05.21 1.51.25.32.03.58.25.67.56.08.31-.04.63-.3.81-.66.45-1.49.83-2.54 1.17l-1.58.52c-1.15.36-2.15.54-3.05.54-2.57 0-4.21-1.54-5.26-4.79zM6.49 6.64c-3.57 1.15-4.42 2.83-3.27 6.41L4.5 17c1.16 3.57 2.84 4.43 6.41 3.28l1.58-.52c.06-.02.11-.04.17-.06l-1.06-.25c-4.61-1.09-6.12-3.53-5.04-8.13l.98-4.19c.07-.32.15-.63.24-.91l-1.29.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.3 10.49-4.85-1.23a.75.75 0 0 1 .37-1.45l4.85 1.23a.748.748 0 0 1-.18 1.47c-.06 0-.12-.01-.19-.02zM14.37 13.87l-2.91-.74a.75.75 0 0 1 .37-1.45l2.91.74c.4.1.64.51.54.91-.08.34-.38.56-.72.56-.06 0-.12-.01-.19-.02z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineNote2);
export default __webpack_public_path__ + "static/media/vuesax-outline-note-2.7e6d1deea9843975a3a31b719fe909f2.svg";
export { ForwardRef as ReactComponent };